// extracted by css-extract-rspack-plugin
export default {"root":"root-Bbcnfu","toggleButtonContainer":"toggleButtonContainer-Ow4kN0"};